(() => {
  const normalize = value => value.replace(/Full Support\s*(?:\/|or)\s*Lifetime|Full Support \(Lifetime\)/g, 'Full Support').replace(/Lifetime/g, 'Full Support').replace(/2023\+/g, '2023–2026');
  const rewriteText = node => {
    if (node.nodeType !== Node.TEXT_NODE || !node.parentElement || node.parentElement.closest('script,style,textarea,noscript')) return;
    let value = normalize(node.nodeValue);
    const group = node.parentElement.closest('#key_options_block [role="group"]');
    if (group && /SOTF/i.test(group.textContent) && /switch/i.test(group.textContent)) value = value.replace(/\*?Not Required\*?/gi, "Needed for SOTF tuning if you don't already have a switch");
    if (value !== node.nodeValue) node.nodeValue = value;
  };
  const process = root => {
    if (root.nodeType === Node.TEXT_NODE) return rewriteText(root);
    if (root.nodeType !== Node.ELEMENT_NODE || root.matches('script,style,textarea,noscript')) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;while ((node = walker.nextNode())) rewriteText(node);
    root.querySelectorAll('#key_options_block [role="group"]').forEach(group => {
      if (!/SOTF/i.test(group.textContent) || !/switch/i.test(group.textContent) || group.querySelector('[data-ild-switch-help]')) return;
      const note = document.createElement('p');note.dataset.ildSwitchHelp = '';note.className = 'ild-switch-explainer';
      note.textContent = "Needed for SOTF tuning if you don't already have a switch. Single Tune uses one fixed file; physical-switch SOTF uses a compatible switch to select levels. Cruise-control SOTF uses supported cruise-control buttons instead.";
      group.append(note);
    });
  };
  document.addEventListener('change', event => {
    const select = event.target.closest?.('[data-truck-type-choice]');if (!select) return;
    if (select.selectedOptions[0]?.hasAttribute('data-cab-check')) {
      select.setCustomValidity(select.dataset.error);
      window.location.assign(select.dataset.cabUrl);
    } else select.setCustomValidity('');
  }, true);
  document.addEventListener('submit', event => {
    const select = event.target.elements?.namedItem('properties[Truck type]');
    if (!select || select.value === 'Pickup') return;
    event.preventDefault();event.stopImmediatePropagation();select.setCustomValidity(select.dataset.error);select.reportValidity();select.focus();
  }, true);
  process(document.body);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'characterData') rewriteText(record.target);
      else for (const node of record.addedNodes) process(node);
    }
  }).observe(document.body,{subtree:true,childList:true,characterData:true});
})();
